import React from 'react'
import { Modal } from 'antd'
import { AiFillExclamationCircle } from 'react-icons/ai'

const Confirm = ({ title = "Perform this action?", message = "", okText ="Proceed", onOk = () => null, cancelText = "Cancel", onCancel = () => null, severity = 'primary' }) => {
    Modal.confirm({
        title,
        icon: <AiFillExclamationCircle color={ severity === 'primary' ? 'blue' : severity === 'warning' ? 'yellow' : 'red'} />,
        content: message,
        okText,
        okType: severity,
        cancelText,
        onOk,
        onCancel
    })
}

export default Confirm